import React from 'react';
import { X } from 'lucide-react';
import { ChatWindow } from './ChatWindow';
interface ProductDescriptionModalProps {
  isOpen: boolean;
  onClose: () => void;
  onComplete: () => void;
}
export const ProductDescriptionModal = ({
  isOpen,
  onClose,
  onComplete
}: ProductDescriptionModalProps) => {
  if (!isOpen) return null;
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" data-id="element-1435">
      <div className="relative w-[600px]" data-id="element-1436">
        <button onClick={onClose} className="absolute -top-10 right-0 text-white hover:text-gray-200" data-id="element-1437">
          <X size={24} data-id="element-1438" />
        </button>
        <div className="bg-white rounded-lg p-6" data-id="element-1439">
          <h2 className="text-xl font-semibold mb-4" data-id="element-1440">
            Tell us about your product
          </h2>
          <p className="text-gray-600 mb-6" data-id="element-1441">
            Describe your product or service to help us create personalized
            outreach messages
          </p>
          <ChatWindow title="Product Description" placeholder="Describe your product or service..." detailLevel={3} onComplete={onComplete} data-id="element-1442" />
        </div>
      </div>
    </div>;
};